import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "qbe-filter-dialog",
    class: "p-fluid kn-dialog--toolbar--primary",
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-2 p-col-12" }, {
        start: _withCtx(() => [
          _createVNode("span", null, _toDisplayString(_ctx.$t('qbe.detailView.toolbarMenu.sql')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.ok')), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode("div", {
        innerHTML: _ctx.sqlFormats.sqlFormatted,
        class: "sqlContent"
      }, null, 8, ["innerHTML"])
    ]),
    _: 1
  }, 8, ["visible"]))
}